/**
 * Import Modal Component
 * 
 * Modal for importing tasks from JSON.
 */

import React from 'react';
import { ABLE_COLORS } from '../../constants';

export default function ImportModal({
  showImportModal,
  setShowImportModal,
  importText,
  setImportText,
  onImport
}) {
  if (!showImportModal) return null;

  return (
    <div 
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.5)',
        zIndex: 2000,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px'
      }}
      onClick={() => setShowImportModal(false)}
    >
      <div 
        style={{
          background: 'white',
          borderRadius: '20px',
          padding: '24px',
          maxWidth: '600px',
          width: '100%',
          maxHeight: '80vh',
          overflow: 'auto',
          boxShadow: '0 8px 40px rgba(0,0,0,0.1)',
          position: 'relative',
          left: 'calc(var(--chat-width, 0px) / -2)',
          transition: 'left 0.2s ease'
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <h2 style={{ 
          margin: '0 0 20px 0',
          fontSize: '20px',
          color: ABLE_COLORS.primary
        }}>
          Import Tasks
        </h2>

        <p style={{
          margin: '0 0 16px 0',
          fontSize: '14px',
          color: '#666'
        }}>
          Paste your JSON data below:
        </p>

        <textarea
          value={importText}
          onChange={(e) => setImportText(e.target.value)}
          placeholder='Paste JSON here... (e.g., {"tasks": [...]})'
          rows={12}
          style={{
            width: '100%',
            padding: '12px',
            border: `2px solid ${ABLE_COLORS.borderMedium}`,
            borderRadius: '8px',
            fontSize: '13px',
            fontFamily: 'monospace',
            outline: 'none',
            boxSizing: 'border-box',
            resize: 'vertical',
            marginBottom: '16px'
          }}
        />

        <div style={{ display: 'flex', gap: '12px' }}>
          <button
            onClick={() => setShowImportModal(false)}
            style={{
              flex: 1,
              padding: '12px',
              background: 'white',
              color: '#666',
              border: `2px solid ${ABLE_COLORS.borderMedium}`,
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '16px',
              fontWeight: '600'
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => onImport(true)}
            disabled={!importText.trim()}
            style={{
              flex: 1,
              padding: '12px',
              background: importText.trim() 
                ? `linear-gradient(135deg, ${ABLE_COLORS.warm} 0%, ${ABLE_COLORS.accent} 100%)` 
                : '#CCC',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: importText.trim() ? 'pointer' : 'not-allowed',
              fontSize: '16px',
              fontWeight: '600',
              opacity: importText.trim() ? 1 : 0.5,
              boxShadow: importText.trim() ? `0 4px 12px ${ABLE_COLORS.warm}40` : 'none',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              if (importText.trim()) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = `0 6px 20px ${ABLE_COLORS.warm}50`;
              }
            }}
            onMouseLeave={(e) => {
              if (importText.trim()) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = `0 4px 12px ${ABLE_COLORS.warm}40`;
              }
            }}
          >
            Replace All
          </button>
          <button
            onClick={() => onImport(false)}
            disabled={!importText.trim()}
            style={{
              flex: 1,
              padding: '12px',
              background: importText.trim() 
                ? `linear-gradient(135deg, ${ABLE_COLORS.primary} 0%, ${ABLE_COLORS.secondary} 100%)` 
                : '#CCC',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              cursor: importText.trim() ? 'pointer' : 'not-allowed',
              fontSize: '16px',
              fontWeight: '600',
              opacity: importText.trim() ? 1 : 0.5,
              boxShadow: importText.trim() ? `0 4px 12px ${ABLE_COLORS.primary}40` : 'none',
              transition: 'all 0.3s ease'
            }}
            onMouseEnter={(e) => {
              if (importText.trim()) {
                e.target.style.transform = 'translateY(-2px)';
                e.target.style.boxShadow = `0 6px 20px ${ABLE_COLORS.primary}50`;
              }
            }}
            onMouseLeave={(e) => {
              if (importText.trim()) {
                e.target.style.transform = 'translateY(0)';
                e.target.style.boxShadow = `0 4px 12px ${ABLE_COLORS.primary}40`;
              }
            }}
          >
            Add Tasks
          </button>
        </div>
      </div>
    </div>
  );
}
